module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/chart-line-4eb1bf05255690056e16c7b9d02f47dc.svg";